<template>
    <v-content>
        <v-container
            class="fill-height"
            fluid
        >
            <v-card class="elevation-12 main-container">
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <form>
                        <v-row>
                            <v-col cols="12" v-if="errors.length">
                                <b>Please correct the following error(s):</b>
                                <ul>
                                    <li v-for="error in errors" :key="error.value">{{ error }}</li>
                                </ul>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" >
                                <v-text-field
                                    label="Name"
                                    name="Name"
                                    type="text"
                                    v-model="inputs.name"
                                ></v-text-field>
                            </v-col> 
                            <v-col cols="6" >
                                <v-text-field
                                    label="Email"
                                    name="Email"
                                    type="email"
                                    v-model="inputs.email"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" >
                                <v-text-field
                                    label="Password"
                                    name="password"
                                    type="password"
                                    v-model="inputs.password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" >
                                <v-text-field
                                    label="Password confirmation "
                                    name="passwordConfirm"
                                    type="password"
                                    v-model="inputs.passwordConfirm"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </form>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="default" @click="restForm" >Reset Form</v-btn>
                    <v-btn color="primary" @click="save" >Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    name:'Register',
    props: {
      source: String,
    },
    data: () => ({
        formTitle:'Registration form',
        errors: [],
        inputs:{
            name: null,
            email: null,
            password: null,
            passwordConfirm: null,
        }
    }),
    methods: {
        checkForm () {
            if (this.name && this.age) {
                return true;
            }

            this.errors = [];

            if (!this.inputs.name) {
                this.errors.push('Name required.');
            }
            if (!this.inputs.email){ //this.validEmail(this.inputs.email) ) {
                this.errors.push('Email required.');
            }
            if (!this.inputs.password) {
                this.errors.push('Password required.');
            }
            if (!this.inputs.passwordConfirm) {
                this.errors.push('Password confirmation required.');
            }

            if( this.errors.length>0 ){ return false; }else{ return true;}
        },
        // validEmail: function (email) {
        //     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //     return re.test(email);
        // },
        save (){
            if( this.checkForm() ){

                // Vue.axios
                //     .get( this.$store.store.apiUrl + '/login' )
                //     .then((response) => {
                            //this.$store.commit("setAuthentication", true);
                            // Go to dash
                            //this.$router.replace("/Dash");
                //     })
                //     .catch( ( error ) => {
                            //window.console.log("The username and / or password is incorrect");
                //     })

                // Go to login on success
                this.$router.replace("/Login");
            }
            
        },
        restForm (){

            // Empty from
            this.inputs = {
                name: null,
                email: null,
                password: null,
                passwordConfirm: null
            };

            // Empty errors log
            this.errors = [];    
        }
    }
  }
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .main-container{
    width: 60%; 
    margin-top:20%; 
    margin:0 auto;
  }
</style>